export default __webpack_public_path__ + "static/Screenshot1-b7f2a2c63ddaebf4e3c976310ce929c5.jpg";